import React from 'react';
import { Progress, Typography } from 'antd';
import { SEOScore } from '../hooks/useSEOAnalysisPanel';

const { Text } = Typography;

interface ScoreLevel {
    status: 'success' | 'exception' | 'normal' | 'active';
    text: string;
    color: string;
}

interface SEOScoreOverviewProps {
    seoScore: SEOScore;
    scoreLevel: ScoreLevel;
}

export const SEOScoreOverview: React.FC<SEOScoreOverviewProps> = ({ seoScore, scoreLevel }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 16 }}>
            <div style={{ textAlign: 'center' }}>
                <Progress
                    type="circle"
                    percent={seoScore.overall}
                    size={80}
                    status={scoreLevel.status}
                    format={() => (
                        <div>
                            <div style={{ fontSize: 20, fontWeight: 'bold' }}>{seoScore.overall}</div>
                            <div style={{ fontSize: 12, color: scoreLevel.color }}>{scoreLevel.text}</div>
                        </div>
                    )}
                />
            </div>
            <div style={{ flex: 1 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    <div>
                        <Text type="secondary">关键词覆盖</Text>
                        <Progress percent={seoScore.breakdown.keywordDensity * 4} size="small" showInfo={false} />
                    </div>
                    <div>
                        <Text type="secondary">可读性</Text>
                        <Progress percent={seoScore.breakdown.readability * 4} size="small" showInfo={false} />
                    </div>
                    <div>
                        <Text type="secondary">合规性</Text>
                        <Progress percent={seoScore.breakdown.compliance * 4} size="small" showInfo={false} />
                    </div>
                    <div>
                        <Text type="secondary">结构完整</Text>
                        <Progress percent={seoScore.breakdown.structure * 4} size="small" showInfo={false} />
                    </div>
                </div>
            </div>
        </div>
    );
};
